import { useSelector } from "react-redux"
import CaseSummaryItem from "./CaseSummaryItem"

const CaseSummaryDetails = () => {

    const activeCase = useSelector(state => state.case.activeCase) 

    return <>
        {activeCase && <CaseSummaryItem itemData={activeCase} apiCase={'case_additional'} permissionType={'case_summary'}/>}
    </>
}

export default CaseSummaryDetails